import { mixins, theme } from '@approvalmax/theme';
import ReactCalendar from 'react-calendar';
import styled from 'styled-components';

export const Root = styled(ReactCalendar)`
    max-width: 100%;

    .react-calendar {
        &--doubleView {
            width: 624px;
        }

        &--doubleView &__viewContainer {
            display: flex;

            > * {
                width: 50%;
            }
        }

        button {
            margin: 0;
            border: 0;
            outline: none;
            display: inline-flex;
            tabindex: -1;

            &:enabled:hover {
                cursor: pointer;
            }
        }

        &__navigation {
            display: grid;
            gap: 4px;
            margin-bottom: 16px;

            :has(> :last-child:nth-child(5)) {
                grid-template-columns: repeat(2, max-content) auto repeat(2, max-content);
            }

            :has(> :last-child:nth-child(3)) {
                grid-template-columns: max-content auto max-content;
            }

            button {
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: ${theme.radius.xsmall};
                cursor: pointer;
                transition: ${theme.duration.medium}ms;

                &:disabled {
                    color: ${theme.color.midnight50};
                    cursor: default;
                }

                &:enabled:hover,
                :focus {
                    background-color: ${theme.color.silver80};
                }
            }

            &__label {
                display: flex;
                align-items: center;
                justify-content: center;
                color: ${theme.color.midnight100};
                ${mixins.font('label', 'small', 'medium')};
            }

            &__next2-button,
            &__prev2-button,
            &__next-button,
            &__prev-button {
                width: 28px;
                height: 28px;
                flex-shrink: 0;
                color: ${theme.color.midnight100};
                font-size: 12px;
            }
        }

        &__month-view__weekdays {
            text-align: center;
            color: ${theme.color.midnight70};
            ${mixins.font('label', 'small', 'regular')};
        }

        &__month-view__weekdays__weekday {
            width: 40px;
            flex: initial !important;
            margin-bottom: 8px;

            abbr {
                text-decoration: none;
            }
        }

        &__month-view {
            &__days {
                &__day {
                    width: 32px;
                    color: ${theme.color.midnight80};

                    &--weekend {
                        color: ${theme.color.red80};
                    }

                    &--neighboringMonth {
                        color: ${theme.color.midnight60};
                    }
                }
            }
        }

        &__year-view {
            &__months {
                height: 160px;
            }

            .react-calendar__tile {
                width: 33.333%;
            }
        }

        &__decade-view {
            &__years {
                height: 160px;
            }

            .react-calendar__tile {
                width: 33.333%;
            }
        }

        &__century-view {
            &__decades {
                height: 200px;
            }

            .react-calendar__tile {
                width: 50%;
            }
        }

        &__year-view,
        &__decade-view,
        &__century-view {
            .react-calendar__tile {
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        &__tile {
            background: none;
            height: 32px;
            border-radius: ${theme.radius.xsmall};
            flex: initial !important;
            cursor: pointer;
            transition: ${theme.duration.medium}ms;

            > abbr {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 100%;
            }

            &:disabled {
                color: ${theme.color.midnight50};
                cursor: default;
            }

            &:enabled:hover,
            &:focus:not(&--active) {
                background-color: ${theme.color.silver80};
            }

            &:focus:not(&--active) {
                color: ${theme.color.midnight100};
            }

            &--now {
                box-shadow: inset 0 0 0 1px ${theme.color.blue80};

                &:enabled:hover {
                    box-shadow: inset 0 0 0 1px ${theme.color.blue100};
                    background-color: transparent;
                }
            }

            &--hasActive,
            &--active {
                background: ${theme.color.blue80};
                color: ${theme.color.white100};

                &:enabled:hover,
                :focus {
                    background: ${theme.color.blue100};
                }
            }
        }

        &--selectRange .react-calendar__tile--hover {
            background-color: red;
        }
    }

    a,
    button,
    input,
    select,
    textarea,
    [tabindex]:not([tabindex='-1']) {
        &:focus:not(:focus-visible) {
            outline: none;
        }
    }
`;
